import { Alert } from 'foundations-components/transitional/components/Alert';
import { ApprovalErrorAlertI18nMessage, ApprovalErrorAlertI18nTitle } from '../i18n/ApprovalErrorAlertI18n';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const ApprovalRequestAccessModalError = props => {
  const {
    errorSubCategory,
    approvalType
  } = props;
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "500",
    as: "div",
    children: /*#__PURE__*/_jsx(Alert, {
      titleText: /*#__PURE__*/_jsx(ApprovalErrorAlertI18nTitle, {
        approvalType: approvalType,
        errorSubCategory: errorSubCategory
      }),
      type: "danger",
      children: /*#__PURE__*/_jsx(ApprovalErrorAlertI18nMessage, {
        approvalType: approvalType,
        errorSubCategory: errorSubCategory
      })
    })
  });
};
export default ApprovalRequestAccessModalError;